import React, { useState, useEffect, useRef } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Mousewheel } from 'swiper/modules';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/autoplay';
import '../components-css/our-clients.scss';

import axios from 'axios';
import { BASE_URL } from '../config';
import AOS from 'aos';
import 'aos/dist/aos.css';

function OurClients({ checkcolor }) {
    const [hoveredLogo, setHoveredLogo] = useState(null);
    const [brandsData, setBrandsData] = useState(null);
    const [isColorCheck, setCheckColor] = useState(null);
    const sectionRef = useRef(null);
    const swiperRef = useRef(null);

    useEffect(() => {
        if (checkcolor === "color") {
            setCheckColor(true);
        }
    }, [checkcolor]);

    useEffect(() => {
        const getClientsData = async () => {
            try {
                let response = await axios.get(`${BASE_URL}/brand`);
                setBrandsData(response.data.data);
            } catch (error) {
                console.log(error);
            }
        };
        getClientsData();
    }, []);

    useEffect(() => {
        AOS.init({
            duration: 1000,
            easing: 'ease-in-out',
            once: true,
            offset: 50
        });

        const handleScroll = () => {
            AOS.refresh();
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    const handleMouseEnter = (index) => {
        setHoveredLogo(index);
        // Stop autoplay on hover
        if (swiperRef.current?.autoplay) {
            swiperRef.current.autoplay.stop();
        }
    };

    const handleMouseLeave = () => {
        setHoveredLogo(null);
        // Resume autoplay after hover
        if (swiperRef.current?.autoplay) {
            swiperRef.current.autoplay.start();
        }
    };

    useEffect(() => {
        let timeoutId;
      
        const observer = new IntersectionObserver(
          ([entry]) => {
            if (!swiperRef.current) return;
      
            if (entry.isIntersecting) {
              // ⏳ Start after 1 second
              timeoutId = setTimeout(() => {
                swiperRef.current?.autoplay.start();
              }, 2000);
            } else {
              // Stop immediately when out of view
              swiperRef.current.autoplay.stop();
      
              // Clear pending timeout
              if (timeoutId) {
                clearTimeout(timeoutId);
              }
            }
          },
          {
            threshold: 0.3 // 30% visible (better than 1)
          }
        );
      
        if (sectionRef.current) {
          observer.observe(sectionRef.current);
        }
      
        return () => {
          if (sectionRef.current) {
            observer.unobserve(sectionRef.current);
          }
          if (timeoutId) {
            clearTimeout(timeoutId);
          }
        };
      }, []);
      

    return (
        <div className='our-clients-main-container' ref={sectionRef}>
            <h2>We've revolutionized your interaction with these global giants.</h2>
            <div className="brands-logo">
                {brandsData && brandsData.length > 0 && (
                    <Swiper
                        onSwiper={(swiper) => {
                            swiperRef.current = swiper;
                        }}
                        slidesPerView={6}
                        spaceBetween={20}
                        loop={true}
                        mousewheel={{
                            forceToAxis: true,
                            sensitivity: 1,
                            thresholdDelta: 40,
                        }}
                        autoplay={{
                            delay: 0,
                            disableOnInteraction: false,
                            pauseOnMouseEnter: false,
                            enabled: false, // 👈 IMPORTANT
                        }}

                        speed={3000} // Smooth transition speed
                        freeMode={false}
                        breakpoints={{
                            1024: { slidesPerView: 6 },
                            500: { slidesPerView: 3 },
                            280: { slidesPerView: 2 }
                        }}
                        modules={[Autoplay, Mousewheel]}
                        className="brands-swiper"
                    >
                        {brandsData.map((brand, index) => (
                            <SwiperSlide key={brand.id || index}>
                                <div
                                    className="img"
                                    onMouseEnter={() => handleMouseEnter(index)}
                                    onMouseLeave={handleMouseLeave}
                                    data-aos="fade-up"
                                >

                                    <img
                                        src={hoveredLogo === index
                                            ? brand.file_path + brand.image
                                            : brand.file_path + brand.black_and_white_image}
                                        alt={brand.name || `Brand ${index + 1}`}
                                        loading="lazy"
                                    />

                                </div>
                            </SwiperSlide>
                        ))}
                    </Swiper>
                )}
            </div>
        </div>
    );
}

export default OurClients;